<template>
    <div class="cart-section">
        <div class="cart-header">
            <h2>Ваш заказ</h2>
            <button class="edit-button" @click="handleEditMode">Добавить ещё</button>
        </div>

        <div class="cart-container">
            <div v-for="cartItem in cart" :key="cartItem.item.name" class="cart-item">
                <div class="item-image">
                    <img :src="`${cartItem.item.imgUrl}`" :alt="cartItem.item.name" />
                </div>

                <div class="item-details">
                    <h3>{{ cartItem.item.name }}</h3>
                    <p class="item-description">{{ cartItem.item.description }}</p>
                    <div class="item-quantity-controls">
                        <button class="cart-qty-btn" @click="updateQuantity(cartItem, -1)">-</button>
                        <span class="cart-qty-text">{{ cartItem.quantity }}</span>
                        <button class="cart-qty-btn" @click="updateQuantity(cartItem, 1)">+</button>
                    </div>
                </div>


                <div class="item-price">
                    <p>{{ cartItem.item.price * cartItem.quantity }}₽</p>
                </div>
            </div>
        </div>

        <div class="cart-summary">
            <div v-if="totalDiscount > 0">
                <p class="original-price"><s>{{ totalPrice + totalDiscount }}₽</s></p>
                <p>Итого со скидкой: {{ totalPrice }}₽</p>
                <p>Скидка: {{ totalDiscount }}₽</p>
            </div>
            <div v-else>
                Итого: {{ totalPrice }}₽
            </div>
            <div v-if="coffeeRubles > 0">
                Вам будет начилено {{ coffeeRubles }} коферублей!
            </div>
        </div>
    </div>

    <div class="comment-section">
        <input type="text" v-model="comment" class="comment-input" placeholder="Комментарий к заказу" />
        <p class="comment-descr">
            Дополнительные пожелания, детали
        </p>
    </div>

</template>



<script>
import { onMounted, onUnmounted, ref, computed } from 'vue';

export default {
    props: {
        cart: Array,
    },
    emits: ['edit-cart', 'send-cart', 'update-quantity'],
    setup(props, { emit }) {
        let comment = ref('');

        function sendCart() {
            console.log('Send cart clicked');
            emit('send-cart', { comment: comment.value, totalQty: totalQuantity.value, totalPrice: totalPrice.value, totalDiscount: totalDiscount.value, coffeeRubles: coffeeRubles.value });
        }

        function handleEditMode() {
            emit('edit-cart');
        }

        function updateQuantity(cartItem, change) {
            emit('update-quantity', { coffee: cartItem.item, change });
        }

        // Compute total quantity
        const totalQuantity = computed(() => {
            return props.cart.reduce((total, item) => total + item.quantity, 0);
        });

        // Compute total discount (Original: 25₽/pack, Vertuo: 50₽/pack)
        const totalDiscount = computed(() => {
            if (totalQuantity.value < 10) return 0;
            return props.cart.reduce((sum, cartItem) => {
                const perPack = cartItem.item.capsuleType === 'original' ? 25 : 50;
                return sum + perPack * cartItem.quantity;
            }, 0);
        });

        // Calculate total price with potential discount
        const totalPrice = computed(() => {
            let total = 0;
            props.cart.forEach(cartItem => {
                const discount = totalQuantity.value >= 10
                    ? (cartItem.item.capsuleType === 'original' ? 25 : 50)
                    : 0;
                total += (cartItem.item.price - discount) * cartItem.quantity;
            });
            return total;
        });

        const coffeeRubles = computed(() => {
            const price = totalPrice.value;
            return Math.round(price/100*3);
        });

        onMounted(() => {
            console.log('Cart mounted, setting up buttons');
            window.Telegram.WebApp.BackButton.show();
            window.Telegram.WebApp.MainButton.setParams({
                text: 'Отправить заказ',
                isVisible: true
            });
            window.Telegram.WebApp.onEvent('mainButtonClicked', sendCart);
        })

        onUnmounted(() => {
            console.log('Cart unmounted, cleaning up');
            window.Telegram.WebApp.offEvent('mainButtonClicked', sendCart);
        })

        return { comment, sendCart, handleEditMode, updateQuantity, totalQuantity, totalPrice, totalDiscount, coffeeRubles }
    }
}
</script>

<style scoped>
.cart-section {
    width: 100%;
    background-color: white;
    margin-bottom: 20px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.cart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.cart-header h2 {
    text-transform: uppercase;
    color: #876C43;
    font-size: 24px;
    font-weight: 600;
    margin: 0;
}

.cart-container {
    background-color: #FAF9F8;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.cart-item {
    display: grid;
    grid-template-columns: min-content 1fr 10%;
    gap: 16px;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #E5D5BB;
}

.cart-item:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.item-image img {
    width: 100px;
    height: auto;
    border-radius: 8px;
}

.item-details h3,
.item-details p,
.item-price p {
    margin: 0;
}

.item-details h3 {
    color: #333;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
}

.item-description {
    color: #666;
    font-size: 14px;
}

.item-price p {
    text-align: right;
    padding-right: 16px;
    color: #876C43;
    font-weight: 600;
    font-size: 16px;
}

.comment-section {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.comment-input {
    width: 100%;
    padding: 15px;
    border: 2px solid #E5D5BB;
    border-radius: 8px;
    color: #333;
    background-color: #FAF9F8;
    resize: vertical;
    margin-bottom: 10px;
    box-sizing: border-box;
    font-family: inherit;
    font-size: 14px;
}

.comment-input:focus {
    outline: none;
    border-color: #876C43;
}

.comment-descr {
    padding: 0;
    color: #666;
    font-size: 13px;
    margin: 0;
}

.edit-button {
    border: none;
    color: #876C43;
    background-color: transparent;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: color 0.3s ease;
}

.edit-button:hover {
    color: #A08060;
}

.item-quantity-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
}

.cart-qty-btn {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: none;
    background-color: rgb(37, 122, 87);
    color: white;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
}

.cart-qty-btn:hover {
    background-color: rgb(30, 100, 70);
}

.cart-qty-text {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    min-width: 20px;
    text-align: center;
}

.cart-summary {
    color: #333;
    padding: 15px;
    background-color: #FAF9F8;
    border-radius: 8px;
    font-size: 16px;
    line-height: 1.8;
}

.cart-summary .original-price {
    color: #999;
    font-size: 14px;
}

@media (max-width: 768px) {
    .cart-section {
        padding: 15px;
    }

    .cart-header h2 {
        font-size: 20px;
    }

    .cart-item {
        grid-template-columns: 80px 1fr auto;
        gap: 12px;
    }

    .item-image img {
        width: 80px;
    }

    .item-details h3 {
        font-size: 14px;
    }

    .item-description {
        font-size: 12px;
    }
}

@media (max-width: 480px) {
    .cart-item {
        grid-template-columns: 60px 1fr;
        gap: 8px;
    }

    .item-image img {
        width: 60px;
    }

    .item-price {
        grid-column: 1 / -1;
    }

    .item-price p {
        text-align: left;
        padding-right: 0;
    }
}
</style>